import React from "react";
import { Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";

const BusinessLastName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="lastName"
      label="Owner Last Name"
      rules={[
        {
          required: true,
          message: "Please input owner last name",
        },
        {
          pattern: /^[A-Za-z ]+$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input
        showCount
        maxLength={32}
        prefix={<UserOutlined className="form-item-icon" />}
        placeholder="Owner Last Name"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default BusinessLastName;
